(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class NewInProductList extends HTMLElement {
    connectedCallback() {
      const productsUrl = this.dataset.productsUrl;

      if (!productsUrl || this.dataset.loading === 'true' || this.dataset.loaded === 'true') return;

      if (!window.IntersectionObserver) {
        this.startLoading(productsUrl);
        return;
      }

      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;

          this.intersectionObserver?.disconnect();
          this.startLoading(productsUrl);
        },
        { rootMargin: '250px 0px' }
      );
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.intersectionObserver?.disconnect();
    }

    startLoading(productsUrl) {
      this.dataset.loading = 'true';
      this.loadProducts(productsUrl);
    }

    async loadProducts(productsUrl) {
      try {
        const response = await fetch(productsUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) return;

        const responseHtml = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
        const productCards = [...responseDocument.querySelectorAll('[data-new-in-product-card]')];
        const productSlots = [...this.querySelectorAll('[data-new-in-product-slot]')];

        if (productCards.length === 0 || productSlots.length === 0) return;

        productSlots.forEach((slot, index) => {
          const productCard = productCards[index];

          if (productCard) {
            slot.replaceChildren(productCard.cloneNode(true));
          }
        });

        this.dataset.loaded = 'true';
      } catch {
        this.dataset.loadError = 'true';
      } finally {
        this.dataset.loading = 'false';
      }
    }
  }

  if (!customElements.get('new-in-product-list')) {
    customElements.define('new-in-product-list', NewInProductList);
  }

  } catch(e) { console.error(e); }
})();
})();
